import { useState } from 'react';
import Navbar from './components/Navbar';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import OurValues from './components/OurValues';
import Timeline from './components/Timeline';
import Team from './components/Team';
import Footer from '../home/components/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <BrandStory />
      <OurValues />
      <Timeline />
      <Team />
      <Footer />
    </div>
  );
}
